export function updateProgress(bytesLoaded, session, progressState) {
    if (typeof bytesLoaded !== 'undefined') {
        // Ensure the progress never moves backward or past 100%.
        session.lastLoaded = Math.min(Math.max(session.lastLoaded, bytesLoaded), session.fileSize);
        session.progress.next(progressState);
    }
}
//# sourceMappingURL=updateProgress.js.map